<template>
	<div class="detail">
		<div class="top qjc-flex">
			<div class="left">
				<div class="img-l">
					<img class="qjc-wid-100 qjc-hei-100" src="../../assets/images/PREVENTA_img1.png" ref="largeImg" />
				</div>
				<ul class="img-list qjc-flex">
					<li>
						<img @mouseenter="checkShowImage" class="qjc-wid-100 qjc-hei-100" src="../../assets/images/PREVENTA_img1.png" />
					</li>
					<li>
						<img @mouseenter="checkShowImage" class="qjc-wid-100 qjc-hei-100" src="../../assets/images/PREVENTA_img2.png" />
					</li>
					<li>
						<img @mouseenter="checkShowImage" class="qjc-wid-100 qjc-hei-100" src="../../assets/images/PREVENTA_img3.png" />
					</li>
				</ul>
			</div>
			
			<div class="right">
				<h3 class="qjc-ftw-n">
					<span class="qjc-c-fff">PREVENTA 低氘水</span>
					<span class="qjc-fts-28">欧洲原装进口</span>
					<span class="qjc-fts-28">健康饮水</span>
				</h3>
				<p class="describe qjc-fts-28">低氘水可降低人体内氘浓度，使癌细胞的增殖得到抑制，进而诱发癌细胞自我死亡（细胞凋 亡），从而达到抗癌的效果。</p>
				<div class="price qjc-clearfix qjc-fts-32">
					<span class="price-n">价格</span>
					<span>￥<b class="qjc-ftw-500">894</b></span>
					<div class="freight qjc-fr qjc-fts-28">
						运费¥60.00
					</div>
				</div>
				<div class="classify qjc-clearfix">
					<label class="qjc-fl qjc-fts-28">规格分类</label>
					<ul class="list qjc-fr qjc-fts-28">
						<li class="qjc-fl"
							:class="{ 'active': item.id == classifyActive }"
							v-for="item in classifyList"
							:key="item.id"
							@click="classifyActive = item.id"
						>
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="count qjc-clearfix">
					<label class="qjc-fl qjc-fts-28">数量选择</label>
					<div class="qjc-fr qjc-relative">
						<span @click="count--" class="subtract qjc-fl"></span>
						<input v-model="count" class="qjc-absolute input-number-hide-bg qjc-fl qjc-fts-32 qjc-c-fff" type="number" pattern="\d" />
						<span @click="count++" class="add qjc-fl"></span>
					</div>
				</div>
				<div class="buy qjc-flex">
					<van-button class="buy-btn qjc-fts-36 qjc-c-fff">立即购买</van-button>
					<div class="qjc-fts-28">
						<span>承诺</span>
						<img src="../../assets/images/shop_zpbz.png" />
						<span>正品保障</span>
					</div>
					<div class="qjc-fts-28">
						<span>支付</span>
						<img src="../../assets/images/shop_wxzf.png" />
						<span>微信支付</span>
					</div>
				</div>
			</div>
		</div>
		
		<div class="bottom">
			<h3 class="qjc-fts-36 qjc-ftw-n qjc-texta-c">宝贝详情</h3>
			
			<div class="content">
				<van-image
					v-for="i in 6"
					:key="i"
					width="100%"
					height="auto"
					lazy-load
					:src="require('@/assets/images/shop_detail_img'+ i +'.png')"
					class="qjc-block"
				></van-image>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Button, Image as VanImage, Lazyload } from 'vant'
	
	Vue.use(Button)
	   .use(VanImage)
	   .use(Lazyload);
	
	export default{
		name: 'shopDetail',
		data() {
			return {
				classifyList: [
					{ id: 1, name: '氘浓度125ppm/箱(6瓶/1.5L)' },
					{ id: 2, name: '氘浓度105ppm/箱(6瓶/1.5L)' },
					{ id: 3, name: '氘浓度85ppm/箱(6瓶/1.5L)' },
					{ id: 4, name: '氘浓度65ppm/箱(6瓶/1.5L)' },
					{ id: 5, name: '氘浓度45ppm/箱(6瓶/1.5L)' },
					{ id: 6, name: '氘浓度25ppm/箱(6瓶/1.5L)' }
				],
				classifyActive: '',// 规格分类选中id
				
				count: 1// 数量,默认1
			}
		},
		watch: {
			count(val) {// 数量最小为1
				if(val < 1){
					this.count = 1;
				}
			}
		},
		methods: {
			checkShowImage(e) {
				this.$refs.largeImg.setAttribute('src', e.target.getAttribute('src'));
			}
		}
	}
</script>

<style lang="scss" scoped>
	.detail{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		padding: 0.6rem 0.8rem;
		color: #BCC1CC;
		overflow-y: auto;
		
		.top{
			justify-content: space-between;
			
			.left{
				width: 6rem;
				
				.img-l{
					width: 6rem;
					height: 6rem;
				}
				.img-list{
					justify-content: space-between;
					margin-top: 0.24rem;
					
					li{
						width: 1.84rem;
						height: 1.84rem;
						border-radius: 0.08rem;
						overflow: hidden;
						cursor: pointer;
					}
				}
			}
			
			.right{
				width: 11rem;
				
				h3{
					font-size: 0.4rem;
					
					span{
						vertical-align: middle;
						
						&.qjc-fts-28{
							border: 0.01rem solid #5FD6FF;
							border-radius: 0.04rem;
							color: #5FD6FF;
							line-height: 0.48rem;
							padding: 0 0.16rem;
							margin-left: 0.16rem;
						}
					}
				}
			
				.describe{
					line-height: 0.4rem;
					margin: 0.16rem 0 0.4rem;
				}
			
				.price{
					height: 1rem;
					background-color: rgba(255, 255, 255, .1);
					border-radius: 0.04rem;
					padding-left: 0.29rem;
					
					span{
						display: inline-block;
						color: #FF5034;
						line-height: 0.56rem;
						margin-top: 0.21rem;
						
						&.price-n{
							color: #fff;
							vertical-align: text-bottom;
							margin-right: 0.32rem;
						}
						
						b{
							font-size: 0.56rem;
						}
					}
					.freight{
						color: #BCC1CC;
						line-height: 0.52rem;
						padding: 0 0.32rem;
						margin: 0.24rem 0;
						border-left: 0.01rem solid #979797;
					}
				}
			
				label{
					width: 1.38rem;
				}
				
				.classify{
					margin: 0.4rem 0 0.12rem;
					
					label{
						line-height: 0.6rem;
					}
					
					.list{
						width: 9.6rem;
						
						li{
							line-height: 0.6rem;
							border: 0.01rem solid #979797;
							border-radius: 0.04rem;
							padding: 0 0.32rem;
							margin: 0 0.24rem 0.24rem 0;
							cursor: pointer;
							transition: all .3s;
							
							&.active,
							&:hover{
								color: #5FD6FF;
								border-color: #5FD6FF;
							}
						}
					}
				}
				
				.count{
					label{
						line-height: 0.72rem;
					}
					&>div{
						width: 9.6rem;
						
						span{
							position: relative;
							width: 0.72rem;
							height: 0.72rem;
							font-size: 0.48rem;
							font-weight: 300;
							border: 0.01rem solid #84878F;
							border-radius: 0.04rem;
							background-color: #173C67;
							margin-right: 0.8rem;
							text-align: center;
							z-index: 20;
							
							&:hover{
								background-color: #154276;
								box-shadow: 0 0.01rem 0.1rem 0 inset #39B7E0;
								cursor: pointer;
							}
							
							&::before,
							&.add::after{
								position: absolute;
								top: 50%;
								left: 50%;
								content: '';
								width: 0.29rem;
								height: 0.02rem;
								background-color: #fff;
								transform: translate(-50%, -50%);
							}
							&.add::after{
								transform: translate(-50%, -50%)rotateZ(90deg);
							}
						}
						input{
							top: 0;
							left: 0.02rem;
							width: 2.2rem;
							height: 0.72rem;
							background-color: transparent;
							border: none;
							border-top: 0.01rem solid #84878F;
							border-bottom: 0.01rem solid #84878F;
							text-align: center;
							z-index: 10;
						}
					}
				}
			
				.buy{
					align-items: center;
					margin-top: 0.32rem;
					
					.buy-btn{
						width: 3.6rem;
						height: 0.98rem;
						border-radius: 0.04rem;
						background-color: #E65F3D;
						border: none;
					}
					
					div.qjc-fts-28{
						margin-left: 0.8rem;
						
						img,
						span{
							vertical-align: middle;
						}
						img{
							width: 0.4rem;
							height: 0.4rem;
							margin-left: 0.16rem;
							margin-right: 0.04rem;
						}
					}
				}
				
			}
		
		}
		
		.bottom{
			border-radius: 0.08rem;
			background: rgba(255, 255, 255, 0.1);
			margin-top: 0.32rem;
			
			h3{
				line-height: 1rem;
			}
			
		}
		
	}
</style>
